import { render, staticRenderFns } from "./SpinVoucher.vue?vue&type=template&id=195f0a8e"
import script from "./SpinVoucher.vue?vue&type=script&lang=js"
export * from "./SpinVoucher.vue?vue&type=script&lang=js"
import style0 from "./SpinVoucher.vue?vue&type=style&index=0&id=195f0a8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports